export default __webpack_public_path__ + "static/media/closet5-before2-2048w.85741a7f.png";